/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/Tabs/ToggleBetaLedger/Content",
  onChange
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let tabSelectedLedgerNewChangeData = fromData.useDataChange({ viewPath,
context: 'tab',
path: 'selected.ledger.new',
formatOut: fromHelpers.not,
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let tabSelectedLedgerNewValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.ledger.new',
})
let tabSelectedLedgerNewValueData1 = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.ledger.new',
})
  return (<React.Fragment
>
<button
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 onClick={tabSelectedLedgerNewChangeData}
 {...isHoveredBind}
 style={{'--mr-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 type="grey"
 size="small"
 style={tabSelectedLedgerNewValueData ? "outline" : "filled"}
 data="tab.selected.ledger.new"
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 text={tabSelectedLedgerNewValueData1 ? "Old ledger" : "New ledger"}
 data="tab.selected.ledger.new"
/>
)}
</TysiaTag>
</button>
{children}
</React.Fragment>)
}